import { hexToRGB } from '@famly/stat_ts-utils_hex-to-rgba';
export { 
/**
 * @deprecated import from '@famly/stat_ts-utils_hex-to-rgba' instead
 */
hexToRGB, 
/**
 * @deprecated import from '@famly/stat_ts-utils_hex-to-rgba' instead
 */
hexToRGBList, 
/**
 * @deprecated import from '@famly/stat_ts-utils_hex-to-rgba' instead
 */
hexToRGBString, 
/**
 * @deprecated import from '@famly/stat_ts-utils_hex-to-rgba' instead
 */
hexToRGBA, } from '@famly/stat_ts-utils_hex-to-rgba';
/**
 * @deprecated import `hexToRGB` as a named export from '@famly/stat_ts-utils_hex-to-rgba' instead
 */
export default hexToRGB;
